import React, { useEffect } from 'react'

interface LocationUpload {
    address: string;
    name: string;
    latitude: string;
    longitude: string;
    url: string;
    onSave: any;
}
const LocationUpload:React.FC<LocationUpload> = (props) => {
    const {address, latitude, longitude, name, url, onSave} = props;
    useEffect(() => {
    onSave && onSave(url,"value",address, latitude, longitude, name)
  }, [address, name, latitude, longitude, url]);
    return (
        <div style={{ borderRadius: "10px", overflow: "hidden", marginBottom: "15px" }}>
            <iframe
                src={`https://maps.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`}
                width="100%"
                height="200"
                style={{ border: 0 }}
                loading="lazy"
                title="Location Preview"
            ></iframe>
        </div>
    )
}

export default LocationUpload